export const visitorSiteConfig = {
  siteId: "hongdae",
  siteName: "Hongdae Pocha",
  excludedPathPrefixes: [],
} as const;
